:host {
  font-size: inherit;
}

.icon {
  display: block;
  position: relative;
  width: 1em;
  height: 1em;
}

.icon svg {
  display: block;
  width: 100%;
  height: 100%;
}

.icon svg *[stroke='#00008F' i],
.icon svg *[stroke='#F08700' i] {
  stroke: currentcolor !important;
}

.icon svg *[fill='#00008F' i],
.icon svg *[fill='#F08700' i] {
  fill: currentcolor !important;
}

.icon--xs {
  font-size: var(--icon-size-xs);
}

.icon--sm {
  font-size: var(--icon-size-sm);
}

.icon--md {
  font-size: var(--icon-size-md);
}

.icon--lg {
  font-size: var(--icon-size-lg);
}

.icon--xl {
  font-size: var(--icon-size-xl);
}
